import styled from "styled-components";

interface StylesheetProps {
  isMobile: boolean;
}

const className = "travel-speed__dialog";

const ModalSpeedTravel = styled.div.attrs(
  (props) => ({ ...props, className, id: className })
)<StylesheetProps>`
  display: flex;
  max-height: calc(100% - 64px);
  flex-direction: column;
  position: relative;
  overflow-y: auto;

  .travel-speed__dialog {
    flex-direction: ${(props) => (props.isMobile ? "column" : "")};
    align-items: ${(props) => (props.isMobile ? "flex-start;" : "")};
  }

  .travel-speed__dialog {
    display: ${(props) => (props.isMobile ? "flex" : "")};
  }

  .speed {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
  }

  .travel-speed__dialog__instruction {
    display: flex;
    line-height: 1.4;
    align-items: center;
    gap: 0.2rem;

    .strong {
      color: #666666;
    }
  }
`;

export { ModalSpeedTravel };
